import { render, staticRenderFns } from "./revision_card.vue.js?vue&type=template&id=0d822015&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./revision_card.vue?vue&type=template&id=0d822015&vue3"
import script from "./revision_card.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./revision_card.vue?vue&type=script&lang=js&vue3"
export * from "./revision_card.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./revision_card.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports